import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import * as types from 'modules/tags/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   loading: { creating: boolean, updating: boolean },
 *   ready: boolean,
 * }} TagsUIDetailsReducer
 */

const loadingReducer = combineReducers({
  creating: loading(types.CREATE_TAG),
  updating: loading(types.UPDATE_TAG),
});

const readyReducer = createReducer(false, {
  [types.TAG_DETAILS_READY]: () => true,
  [LOCATION_CHANGE]: () => false
});

export default combineReducers({
  loading: loadingReducer,
  ready: readyReducer,
});
